module.exports = __webpack_public_path__ + "static/img/brand-7.2c99ee1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-7.svg
// module id = vlxt
// module chunks = 0